import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { IAccountBonusData, IBonusFreeSpinV1, IBonusFreeSpinV2 } from '@GFTypes/GameStoreTypes/Account';

export const processBonusData = (data: any[], gameStore: GameStore): IAccountBonusData => {
    const regex = /\bfreespin\b/g;
    const bonusPayload: IAccountBonusData = {};

    //FREE SPINS CHECK
    const fsIndex = data.findIndex((e: IBonusFreeSpinV2 | IBonusFreeSpinV1) => regex.test(e.type));
    if (fsIndex > -1) {
        const freeSpins: IBonusFreeSpinV2 & IBonusFreeSpinV1 = data[fsIndex];

        const fsState = gameStore.get(EGameStoreKeys.Account).bonuses.freeSpins;

        bonusPayload.freeSpins = {
            type: freeSpins.type,
            balance: freeSpins.balance ?? freeSpins.data.balance,
            wagerCost: freeSpins.wagerCost ?? freeSpins.data.wagerCost,
            suspend: fsState ? fsState.suspend : false
        };

        if (bonusPayload.freeSpins.balance === 0) return {};

        if (freeSpins.wagerCost) {
            bonusPayload.freeSpins.requestPayload = { bonusType: freeSpins.type };
        } else {
            bonusPayload.freeSpins.requestPayload = {
                bonus: { id: freeSpins.id, type: freeSpins.type, isInternal: freeSpins.isInternal, context: freeSpins.context }
            };
        }
    }

    return bonusPayload;
};
